import { render, staticRenderFns } from "./addRawMaterial.vue?vue&type=template&id=3d70f120&scoped=true&"
import script from "./addRawMaterial.vue?vue&type=script&lang=js&"
export * from "./addRawMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70f120",
  null
  
)

export default component.exports